<template>
    <v-dialog
        v-model="isOpen"
        max-width="632"
        transition="slide-x-reverse-transition"
        content-class="elevation-0"
        data-testid="logout-confirmation-modal"
    >
        <v-card class="rounded-lg">
            <v-toolbar flat>
                <v-spacer />
                <v-btn
                    icon
                    @click="closeDialog"
                >
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="px-1">
                <v-row class="ma-0">
                    <v-col
                        md="3"
                        cols="12"
                        :class="{'text-center': $vuetify.breakpoint.smAndDown, 'text-right': $vuetify.breakpoint.mdAndUp }"
                    >
                        <v-chip
                            class="ma-2 logout-icon rounded-circle"
                            text-color="white"
                        >
                            <v-icon style="font-size: 50px;" color="white">
                                fas fa-sign-out-alt
                            </v-icon>
                        </v-chip>
                    </v-col>
                    <v-col
                        md="9"
                        cols="12"
                        :class="{'text-center': $vuetify.breakpoint.smAndDown, 'text-left': $vuetify.breakpoint.mdAndUp }"
                    >
                        <div class="text-md-h6 subtitle-1 font-weight-bold ml-md-4 mt-4">
                            {{ $t('header.logoutConfirmationModal.title') }}
                        </div>
                        <div class="subtitle-1 ml-4">
                            {{ $t('header.logoutConfirmationModal.text') }}
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="pb-8">
                <v-row class="ma-0">
                    <v-col cols="12" class="logout-button d-flex justify-center px-md-16">
                        <v-btn
                            class="button-cancel-logout rounded-pill px-5 px-sm-10"
                            elevation="3"
                            @click="closeDialog"
                        >
                            {{ $t('header.logoutConfirmationModal.cancel') }}
                        </v-btn>
                        <v-spacer v-if="$vuetify.breakpoint.mdAndUp" />
                        <v-btn
                            elevation="3"
                            class="button-secondary-color rounded-pill font-weight-bold px-5 mb-5 mb-md-0 logout"
                            @click="logoutAccount"
                        >
                            {{ $t('header.logoutConfirmationModal.logout') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { isUsingKc } from '@/utils';

export default {
    name: 'logout-confirmation-modal',
    computed: {
        ...mapGetters({
            getLogoutConfirmationModal: 'jwt/getLogoutConfirmationModal',
        }),
        isOpen: {
            get: function() {
                return this.getLogoutConfirmationModal;
            },
            set: function(value) {
                this.setCloseLogoutConfirmationDialog(value);
            },
        },
    },
    methods: {
        ...mapMutations({
            setCloseLogoutConfirmationDialog: 'jwt/SET_LOGOUT_CONFIRMATION_MODAL',
        }),
        ...mapActions({
            logout: 'jwt/logout',
            kcLogout: 'kcLogin/logout',
        }),
        closeDialog() {
            this.setCloseLogoutConfirmationDialog();
        },
        async logoutAccount() {
            this.setCloseLogoutConfirmationDialog();
            if (isUsingKc) {
                return this.kcLogout();
            }
            await this.logout();
        },
    },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables';

::v-deep.v-alert--text:before {
    background-color: transparent !important;
}

.logout-icon {
    background-color: $cs-color-secondary !important;
    color: white !important;
    -webkit-box-shadow: 0px 0px 0px 12px $shadow-logout-icon-color !important;
    box-shadow: 0px 0px 0px 12px $shadow-logout-icon-color !important;
    width: 80px !important;
    height: 80px !important;
}

.logout-icon.v-chip {
    padding: 0 20px !important;
}

.logout-button {
    .v-btn {
        height: 50px !important;
    }
    @media only screen and (max-width: 959px) {
        flex-direction: column-reverse;
        .v-btn {
            font-size: 0.8rem!important;
            width: calc(80% - 30px) !important;
            margin: 10px 15%!important;
        }
    }
    @media only screen and (max-width: 320px) {
        .v-btn {
            font-size: 0.6rem !important;
        }
    }
}

</style>
